import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';

import { PresentationsModule } from '../presentations/presentations.module';

import { AiChatbotComponent } from './components/ai-chatbot/ai-chatbot.component';
import { AiChatbotPromptBoxComponent } from './components/ai-chatbot-prompt-box/ai-chatbot-prompt-box.component';
import { AiChatbotCategoryChipComponent } from './components/ai-chatbot-category-chip/ai-chatbot-category-chip.component';
import { AiGeneratePresentationsButtonComponent } from './components/ai-chatbot-generate-presentations-button/ai-chatbot-generate-presentations-button.component';
import { AiChatbotLoadingComponent } from './components/ai-chatbot-loading/ai-chatbot-loading.component';
import { AIChatbotService } from './services/ai-chatbot/ai-chatbot.service';
import { AiChatbotMessageComponent } from './components/ai-chatbot-message/ai-chatbot-message.component';
import { TemplateEditorModule } from '../template-editor/template-editor.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatChipsModule,
    MatMenuModule,
    MatCheckboxModule,
    MatInputModule,
    TemplateEditorModule,
    PresentationsModule,
  ],
  declarations: [
    AiChatbotComponent,
    AiChatbotPromptBoxComponent,
    AiChatbotCategoryChipComponent,
    AiGeneratePresentationsButtonComponent,
    AiChatbotLoadingComponent,
    AiChatbotMessageComponent,
  ],
  exports: [
    AiChatbotComponent,
    AiChatbotPromptBoxComponent,
    AiChatbotCategoryChipComponent,
    AiGeneratePresentationsButtonComponent,
    AiChatbotLoadingComponent,
    AiChatbotMessageComponent,
  ],
  providers: [AIChatbotService],
})
export class AIChatbotModule {}
